/* eslint-disable import/prefer-default-export */
export const WELFARE_MY_CHANNEL = 'WELFARE_MY_CHANNEL';
export const WELFARE_REFRESH_DATA = 'WELFARE_REFRESH_DATA';
export const WELFARE_MY_CHANNEL_COMPLETE = 'WELFARE_MY_CHANNEL_COMPLETE';

// 福利中心模块key配置
export const FULI_MODULE = {
  welfare_attendance: 'welfare_attendance', // 签到
  welfare_attendance_mp: 'welfare_attendance_mp', // 仅支付宝签到
  welfare_task: 'welfare_task', // 任务
  welfare_exclusive: 'welfare_exclusive', // app专享福利
  welfare_cardAndCoupon: 'welfare_cardAndCoupon', // 卡券
  welfare_bountyExchange: 'welfare_bountyExchange', // 兑换
  app_welfare_banner: 'app_welfare_banner', // app banner
  alipay_welfare_banner: 'alipay_welfare_banner', // alipay banner
  welfare_bounty_external_equity: 'welfare_bounty_external_equity', // 外部权益
  welfare_rake_back: 'welfare_rake_back', // 电商返币
  welfare_guide_commodity: 'welfare_guide_commodity', // 引导商品
  welfare_advertisement_video: 'welfare_advertisement_video', // 视频红包
  welfare_attendance_new: 'welfare_attendance_new', // 签到（改版）
  welfare_new_task: 'welfare_new_task', // 任务（改版）
  welfare_notice: 'welfare_center_notice_module', // 通知横幅
  welfare_newcomer_guide: 'welfare_newcomer_guide', // 新人引导
  welfare_takeout_rebate_module: 'welfare_takeout_rebate_module', // 返佣宫格
  welfare_cheese_rebate_module: 'welfare_cheese_rebate_module', // 返佣瓷片
  welfare_banner: 'welfare_banner', // 福利中心 banner（V3+）
  welfare_exchange_float: 'welfare_exchange_float', // 顺风车心智版本通用浮标（命名待与服务端确认）
};

// 福利中心模块组件配置（App端）
export const FULI_MODULE_COMPONENT = {
  // 签到模块
  welfare_attendance: 'check-in',
  // 签到模块（新版）
  welfare_attendance_new: 'sign-in-card',
  // 激励视频模块
  welfare_advertisement_video: 'video-red-packet',
  welfare_surprise_tasks: 'bounty-surprise',
  // 任务模块
  welfare_task: () => ({
    component: import(
      /* webpackChunkName: "second-screen-module" */
      './components/bounty.vue'
    ),
    loading: {
      template: '<div></div>',
    },
    error: {
      template: '<div></div>',
    },
    delay: 200,
    timeout: 10000,
  }),
  // 任务模块（新版）
  welfare_new_task: 'task-module',
  // 商品兑换模块
  welfare_bountyExchange: () => ({
    component: import(
      /* webpackChunkName: "second-screen-module" */
      './new-version-cpns/exchange-module.vue'
    ),
    loading: {
      template: '<div></div>',
    },
    error: {
      template: '<div></div>',
    },
    delay: 200,
    timeout: 10000,
  }),
  // 电商返佣模块
  welfare_rake_back: 'rake-back',
};

// 福利中心-奖励金Tab组件配置（三端）
export const FULI_CENTER_MODULE_COMPONENT = {
  // 精选商品
  welfare_guide_commodity: 'recommended-goods',
  // 激励视频模块
  welfare_advertisement_video: 'video-red-packet',
  // 任务模块
  welfare_task: 'task-module',
  // 电商返佣模块
  welfare_rake_back: 'rake-back',
  // 电商返佣模块v2 宫格模式
  welfare_takeout_rebate_module: 'rake-back',
  // 电商返佣模块v2 瓷片模式
  welfare_cheese_rebate_module: 'rake-back',
  // 商品兑换模块
  welfare_bountyExchange: 'exchange-module',
  // 惊喜任务模块（多单任务 + 惊喜任务）
  welfare_surprise_tasks: 'task-wrapper',
  // 新人引导模块
  welfare_newcomer_guide: 'newcomer-guide',
  // 开宝箱浮标
  treasure_box_float: 'treasure-box-float',
  // 福利中心 banner
  welfare_banner: 'adv-master',
  // 兑换浮标
  welfare_exchange_float: 'exchange-float',
};

// 福利中心模块列表（默认）
export const LOCAL_MODULES = [
  FULI_MODULE.welfare_guide_commodity,
  FULI_MODULE.welfare_rake_back,
];

// 需延迟处理的模块配置
export const DEFERRED_MODULES = [
  FULI_MODULE.welfare_attendance_new,
  FULI_MODULE.welfare_advertisement_video,
];

export const FULI_MODULE_NEW = {
  welfare_task_new: 'welfare_task_new', // 任务
  welfare_exclusive_new: 'welfare_exclusive_new', // app专享福利
  welfare_card_new: 'welfare_card_new', // 抢券
  welfare_bountyExchange: 'welfare_bountyExchange', // 兑换
  alipay_welfare_banner: 'alipay_welfare_banner', // banner
  welfare_bounty_external_equity: 'welfare_bounty_external_equity', // 外部权益
};

export const FULI_MODULE_OLD_TO_NEW = {
  [FULI_MODULE.welfare_task]: FULI_MODULE_NEW.welfare_task_new,
  [FULI_MODULE.welfare_exclusive]: FULI_MODULE_NEW.welfare_exclusive_new,
  [FULI_MODULE.welfare_cardAndCoupon]: FULI_MODULE_NEW.welfare_card_new,
  [FULI_MODULE.welfare_bountyExchange]: FULI_MODULE_NEW.welfare_bountyExchange,
  [FULI_MODULE.alipay_welfare_banner]: FULI_MODULE_NEW.alipay_welfare_banner,
};

export const FULI_MODULE_COMPONENT_NEW = {
  welfare_card_new: 'card-coupons-new', // 卡券  card-coupons
  welfare_exclusive_new: 'card-exclusive', // app专享福利
  welfare_task_new: 'bounty-task', // 任务
  welfare_bountyExchange: 'exchange', // 兑换
  alipay_welfare_banner: 'adv-master', // banner
  welfare_bounty_external_equity: 'external-equity', // 外部权益
};

export const FULI_MODULE_NAV = {
  welfare_task_new: '赚奖励金', // 任务
  welfare_exclusive_new: 'APP专享卡券', // app专享福利
  welfare_card_new: '限时抢券', // 卡券  card-coupons
  welfare_bountyExchange: '用奖励金', // 兑换
  alipay_welfare_banner: 'banner', // banner
};

export const TABS = [
  { name: '推荐', type: undefined },
  { name: '单车', type: '6' },
  { name: '助力车', type: '2' },
  { name: '电动车', type: '1' },
  { name: '火车票', type: '12' },
  { name: '顺风车', type: '3' },
  { name: '全网叫车', type: '11' },
  { name: '送货', type: '13' },
];

export const TIME_COUPON_STATUS = {
  NONE: 1, // 已抢光
  USE: 2, // 去使用
  GRAB: 3, // 抢
  DOUBLE: 4, // 膨胀
  GET: 5, // 免费领
  GO_USE: 6, // 直接去使用
};

export const CARD_COUPON_TYPE = {
  CARD: 1,
  COUPON: 2,
  TIME_COUPON: 3,
  FREE_COUPON: 4,
};

export const CARD_COUPON_TYPE_NEW = {
  CARD: 1,
  COUPON: 2,
  TIME_COUPON: 3,
};

export const COUPON_STATUS = {
  HAS_RECEIVED: 0, // 已经领取
  NOT_RECEIVED: 1, // 未领取
  NO_SKU: 2, // 库存不足
  GO_SWELL_OR_USE: 3, // 去使用或去膨胀
  HAS_SWELL: 4, // 已膨胀
};

export const PART_STATUS = {
  NOT: '2',
  GOING: '1',
  END: '0',
};
// 商业化任务类型
export const MARKET_PLAN = {
  PP_EFFECT_ADTASK: 'pp_effct_adtask',
  MUTIL_TRACE: 'mutil_trace',
  PP_WIDGET: 'pp_widget', // 添加桌面小组件
  ORDER_CROSS_GAME: 'order_cross_game', // 游戏任务聚合
  GDT_TASK: 'ylh', // 优量汇广告任务
};

export const PART_TEXT = {
  [PART_STATUS.NOT]: '即将开始',
  [PART_STATUS.GOING]: '进行中',
  [PART_STATUS.END]: '已结束',
};

export const MODAL_MODULE_TYPE = {
  CANCEL: 0,
  SUCCESS: 1,
};

export const TRUE_ORDER_JUMP_CROSS = [
  'true_order_jump_cross_2key',
  'true_order_jump_cross',
];

export const TrueJumpCrossTasks = [
  ...TRUE_ORDER_JUMP_CROSS,
  'true_jump',
  'true_jump_2key',
];

export const ORDER_JUMP_CROSS = ['order_jump_cross'];
export const WeiboBrowse = ['weibo_browse'];

// 系统设置任务
export const SYSTEM_SETTING_TASKS = ['remind'];
/** 租车企微任务，跳转微信小程序 */
export const JUMP_TO_WX_RENT = ['follow_rent_car_wecom'];

export const AllJumpCrossTasks = [...TrueJumpCrossTasks, ...ORDER_JUMP_CROSS];
export const WhiteList = ['cn.10086.app', 'imgotv', 'ksnebula', 'ctrip'];

// 福利中心首屏弹窗
export const POPUP_WINDOW_KEY = {
  // 签到弹窗
  checkin_window: 'sign_recommend_bounty_exchange',
  // 唤端承接弹窗
  market_window: 'cross_endpoint_transition_popup',
  // 首单引导弹窗（电商返佣）
  beginner_order_window: 'welfare_beginner_guide',
  // 新人玩法引导弹窗
  play_guide_window: 'welfare_play_guide_popup',
  // 新人玩法引导弹窗（新）
  play_guide_window_new: 'welfare_play_guide_popup_new',
  // 新手教育弹窗（商品兑换引导）
  beginner_education_window: 'welfare_new_user_education_popup_new',
  // 首单引导弹窗V2（电商返佣）
  beginner_order_window_v2: 'welfare_beginner_guide_v2',
  // 唤端承接弹窗（投放）
  call_client_window: 'welfare_cross_new_endpoint_transition_popup',
  // 淘宝搜索框聚光灯
  taobao_search_light: 'welfare_commerce_rebate_spot_light_popup',
  // 积分抵扣业务出行订单教育弹窗
  point_deduction_stragegy: 'point_deduction_stragegy_popup_windows',
  // 添加小组件弹窗（直接调用桥方法拉起半屏）
  component_popup: 'welfare_component_popup',
};

// 首屏弹窗样式类型
export const POPUP_STYLE_TYPE = {
  // 个性化弹窗（按 POPUP_WINDOW_KEY 匹配组件）
  CUSTOM: 0,
  // 居中弹窗（窗口浮空展示，关闭按钮在下方）
  CENTER: 1,
};

// 新版首屏弹窗组件映射
export const WELFARE_CENTER_POPUP_WINDOW_COMPONENT = {
  [POPUP_WINDOW_KEY.point_deduction_stragegy]: () => import(
    /* webpackChunkName: "popup-window-module" */
    './new-version-cpns/auto-deduct-popup.vue'
  ),
};

// 首屏弹窗组件映射
export const POPUP_WINDOW_COMPONENT = {
  [POPUP_WINDOW_KEY.market_window]: () => import(
    /* webpackChunkName: "popup-window-module" */
    './components/market-modal.vue'
  ),
  [POPUP_WINDOW_KEY.call_client_window]: () => import(
    /* webpackChunkName: "popup-window-module" */
    './new-version-cpns/call-client-popup.vue'
  ),
  [POPUP_WINDOW_KEY.taobao_search_light]: () => import(
    /* webpackChunkName: "popup-window-module" */
    './new-version-cpns/taobao-search-light-popup.vue'
  ),
  [POPUP_WINDOW_KEY.point_deduction_stragegy]: () => import(
    /* webpackChunkName: "popup-window-module" */
    './new-version-cpns/auto-deduct-popup.vue'
  ),
};

// 单单返奖励领取状态
export const AWARD_COIN_STATUS = {
  // 无可领
  NORMAL: 'NORMAL',
  // 可领
  AWARD: 'AWARD',
  // 即将过期
  PAST_DUE: 'PAST_DUE',
};

// 单单返奖励领取状态映射
export const AWARD_COIN_STATUS_MAP = {
  NORMAL: {
    logo:
      'https://m.hellobike.com/resource/gallery/833/47Q4rxvS_Group%201707483334%20(1).png',
    className: 'normal',
  },
  AWARD: {
    logo:
      'https://m.hellobike.com/resource/gallery/833/_zy09H_k_Group%201707483331%20(1).png',
    className: 'award shine-light',
  },
  PAST_DUE: {
    logo:
      'https://m.hellobike.com/resource/gallery/833/_zy09H_k_Group%201707483331%20(1).png',
    className: 'past-due shine-light',
  },
};

// 签到图标映射
export const SIGN_IN_CARD_ICON_MAP = {
  // 已签到
  signed: 'https://m.hellobike.com/98aa5e80_Frame%202117131582.png',
  // 未签到
  unsigned: 'https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png',
};

// 小组件模板ID
export const WIDGET_TEMPLATE_ID = 'welfare_center';
// 小组件调用来源
export const WIDGET_SOURCE = 'welfare_h5';

// 头部右侧点配置
export const DOT_CONFIG_LIST = [
  {
    name: '默认抵扣订单',
  },
  {
    name: '奖励金规则',
    linkUrl:
      'https://m.hellobike.com/mf/spa/u_yzmpzd/latest/MA2206293249099363266854912.html?activityCode=MA2206293249099363266854912',
  },
  {
    name: '意见反馈',
    linkUrl:
      'https://m.hellobike.com/AppSurveyWebRender/latest/index.html#/r/oLfmlVQq ',
  },
];

// 福利中心页面AB版本
export const WELFARE_VERSION = {
  // 老版福利中心（大AB旧版，只有签到 + 兑换）
  OLD_TASK_SCENE: 'old_task_scene',
  // 新版福利中心
  NEW_TASK_SCENE: 'new_task_scene',
  // 新版福利中心V2（大AB新版）
  NEW_TASK_SCENE_V2: 'new_task_scene_v2',
  // 新版福利中心V3（单tab + 模块固定排序）
  NEW_TASK_SCENE_V3: 'new_task_scene_v3',
  // 新版福利中心V4（聚合tab + 模块固定排序）
  NEW_TASK_SCENE_V4: 'new_task_scene_v4',
  // 新版福利中心V5（聚合tab + 模块动态排序）
  NEW_TASK_SCENE_V5: 'new_task_scene_v5',
};

// 用户类型
export const USER_TYPE = {
  // 新用户
  NEW: 'new',
  // 半新用户
  HALF_NEW: 'half-new',
  // 老用户
  OLD: 'old',
};

/**
 * 缓存key
 */
// 兑换商品选择的skuId
export const STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID = 'STORAGE_KEY_EXCHANGE_GOODS_CHOOSE_SKU_ID';
// 当天展示复访弹窗时间
export const STORAGE_KEY_SHOW_REVISIT_GUIDE_TIME = 'STORAGE_KEY_SHOW_REVISIT_GUIDE_TIME';
// 是否展示过单单返奖励引导弹窗
export const STORAGE_KEY_SHOW_AWARD_GUIDE = 'STORAGE_KEY_SHOW_AWARD_GUIDE';
// 顺风车心智版本：单单返引导弹窗（领取后自动弹）疲劳度 key，与原始版本独立
export const STORAGE_KEY_SHOW_HITCH_AWARD_GUIDE = 'STORAGE_KEY_SHOW_HITCH_AWARD_GUIDE';
// 福利中心模块列表
export const STORAGE_KEY_WELFARE_MODULES = 'welfare_modules';
// 缓存溢出状态
export const STORAGE_KEY_CACHE_OVERFLOW = 'cache_overflow';
// 模块锚定组件展示记录
export const STORAGE_KEY_MODULE_ANCHOR_SHOWN = 'module_anchor_shown';

// 新人兑换商品引导规则兜底数据
export const REWARD_GUIDE_RULES_DEFAULT = [
  {
    minNumber: 0,
    maxNumber: 100,
    guidingDesc: '看2个广告即可达成',
    anchoringModuleKey: 'welfare_advertisement_video',
  },
  {
    minNumber: 101,
    maxNumber: 1000,
    guidingDesc: '点1单外卖即可达成',
    anchoringModuleKey: 'welfare_rake_back',
  },
  {
    minNumber: 1001,
    maxNumber: 2000,
    guidingDesc: '点2单外卖即可达成',
    anchoringModuleKey: 'welfare_rake_back',
  },
  {
    minNumber: 2001,
    maxNumber: 3000,
    guidingDesc: '点3单外卖即可达成',
    anchoringModuleKey: 'welfare_rake_back',
  },
  {
    minNumber: 3001,
    maxNumber: 4000,
    guidingDesc: '点4单外卖即可达成',
    anchoringModuleKey: 'welfare_rake_back',
  },
  {
    minNumber: 4001,
    maxNumber: 5000,
    guidingDesc: '点5单外卖即可达成',
    anchoringModuleKey: 'welfare_rake_back',
  },
  {
    minNumber: 5001,
    maxNumber: -1,
    guidingDesc: '点外卖快速攒币',
    anchoringModuleKey: 'welfare_rake_back',
  },
];

// 看视频红包标题icon兜底
export const VIDEO_RED_PACKET_DEFAULT_ICON = 'https://m.hellobike.com/resource/gallery/833/0NlXuNGw-C.png';
// 签到标题icon兜底
export const SIGN_IN_DEFAULT_ICON = 'https://m.hellobike.com/resource/gallery/833/Ew4_HJmJoR.png';

// 福利中心电商返佣实验版本
export const RAKE_BACK_AB = {
  // 老版电商返佣
  NORMAL: '0',
  // 新版电商返佣+展示签到模块
  NEW_V1: '1',
  // 新版电商返佣+隐藏签到模块
  NEW_V2: '2',
};

// 提现入口场景
export const BONUS_WITHDRAWAL_SCENE = {
  // 展示入口
  SHOW: '1',
  // 隐藏入口
  HIDE: '0',
};

// 任务弹窗按钮文案
export const TASK_POPUP_BTN_NAME = {
  INIT: '领任务',
  RUNNING: '去完成，回来领奖励',
  FINISHED: '领奖励',
};

// 任务模块埋点信息映射
export const TASK_SPM_INFO_MAP = {
  welfare_browse_tasks: {
    moduleExpose: 'Welfare_browsetask',
    btnClick: 'Welfare_browsetask_use',
    moreBtnClick: 'Welfare_browsetask_more',
    // 新版任务模块
    cardModuleExpose: 'Welfare_browsetask_button',
    cardModulePopupExpose: 'Welfare_browsetask_pop',
    cardModulePopupTaskClick: 'Welfare_browsetaskuse',
  },
  welfare_order_completion_task: {
    moduleExpose: 'Welfare_ordertask',
    btnClick: 'Welfare_ordertask_use',
    moreBtnClick: 'Welfare_ordertask_more',
    // 新版任务模块
    cardModuleExpose: 'Welfare_ordertask_button',
    cardModulePopupExpose: 'Welfare_ordertask_pop',
    cardModulePopupTaskClick: 'Welfare_ordertask_popuse',
  },
  platform_newTask: {
    moduleExpose: 'platform_newTask',
    btnClick: 'platform_taskClick',
    moreBtnClick: 'platform_moreTask',
  },
};

// 任务模块类型
export const TASK_MODULE_TYPE = {
  SINGLE_TASK: 'single_task',
  GROUP_TASK: 'group_task',
  DEFAULT_TASK: 'default_task',
};

// 任务模块兜底数据
export const TASK_MODULE_DEFAULT_DATA = {
  taskType: TASK_MODULE_TYPE.DEFAULT_TASK,
  key: 'default_task_module',
  taskModuleInfo: {
    title: '更多任务',
    desc: '更新中，尽情期待',
    moduleBgUrl: 'https://m.hellobike.com/resource/gallery/833/MmQDJPoU_Frame%201707483037.png',
  },
};

// 福利中心玩法引导图片
export const WELFARE_PLAY_GUIDE_LIST = [
  { id: 1, imgUrl: 'https://m.hellobike.com/7b319e15_1.png' },
  { id: 2, imgUrl: 'https://m.hellobike.com/5f790892_2.png' },
  { id: 3, imgUrl: 'https://m.hellobike.com/b0f7c2c6_3.png' },
  { id: 4, imgUrl: 'https://m.hellobike.com/cbb7e4f1_4.png' },
];

// 福利中心玩法引导图片兜底配置
export const PLAY_GUIDE_DEFAULT_IMGS = {
  goodsImageUrl:
    'https://m.hellobike.com/resource/gallery/833/h2OAuG7b_Slice%2018.png',
  twoFramesUrl: 'https://m.hellobike.com/resource/gallery/833/ibXug1EB8l.png',
  threeFramesUrl: 'https://m.hellobike.com/resource/gallery/833/ibXug1EB8l.png',
};

// 电商返佣banner类型
export const RAKE_BACK_BANNER_TYPE = {
  // 单图片banner样式
  SINGLE_IMAGE: '1',
};

// 新人首单banner策略
export const RAKE_BACK_BANNER_STRATEGY = {
  // 新人首单banner
  NEW_ORDER_STRATEGY: 'new_order_strategy',
  // 新人首单banner V2
  NEW_ORDER_STYLE: 'new_order_style',
};

// 新人兑换商品AB实验版本
export const EXCHANGE_GOODS_AB = {
  // 对照组
  CONTROL_GROUP: 'X',
  // aa组
  AA_GROUP: 'Y',
  // 实验组
  TEST_GROUP: 'Z',
};

// 新人玩法引导弹窗key列表
export const PLAY_GUIDE_WINDOW_KEYS = [
  POPUP_WINDOW_KEY.play_guide_window,
  POPUP_WINDOW_KEY.play_guide_window_new,
];

// 头部背景图片
export const TOP_HEADER_BG_IMGS = [
  'https://m.hellobike.com/resource/gallery/919/nseWrwnp4S.png',
  'https://m.hellobike.com/resource/gallery/919/xycgz6G8t2.png',
];

// 福利中心页面key
export const WELFARE_CENTER_PAGE_KEY = {
  bounty: 'bounty',
  coupon: 'coupon',
};

// 福利中心页面配置
export const WELFARE_CENTER_PAGE_CONFIG = {
  bounty: {
    pageKey: WELFARE_CENTER_PAGE_KEY.bounty,
    componentName: 'bounty-tab',
    titleIcon: 'https://m.hellobike.com/85a44d3976.png',
    titleDesc: '奖励金当钱花',
    headerColor: '#fff1ba',
    bgImg: 'https://m.hellobike.com/e925d84e_bg.png',
  },
  coupon: {
    pageKey: WELFARE_CENTER_PAGE_KEY.coupon,
    componentName: 'coupon-tab',
    titleIcon: 'https://m.hellobike.com/23302b7ef3.png',
    titleDesc: '购券下单，越用越省',
    headerColor: '#ffeef1',
    bgImg: 'https://m.hellobike.com/540a3400_bg.png',
  },
};

// 福利中心页面通用头部信息
export const WELFARE_CENTER_COMMON_HEADER_INFO = {
  titleIcon: 'https://m.hellobike.com/63414697e8.png',
  titleDesc: '出行选哈啰 省钱又省心',
};

// 福利中心-顺风车心智版本头部信息（非聚合 tab）
export const WELFARE_CENTER_HITCH_HEADER_INFO = {
  titleIcon: 'https://m.hellobike.com/15f4b77728.png',
  titleDesc: '',
  bgImg: 'https://m.hellobike.com/76964007_bg2.png',
};

// 签到弹窗标签图片
export const SIGN_IN_POPUP_TAG_IMG = {
  // 今日签到可领
  today: 'testImgUrl_今日签到可领',
  // 明日签到可领
  tomorrow: 'testImgUrl_明日签到可领',
};

// 福利中心页面tab配置
export const WELFARE_CENTER_TABS_CONFIG = [
  {
    key: 'bounty',
    tabName: '领奖励金',
    tabActiveColor: '#fff9df',
    tabBgColor: '#fcd06766',
  },
  {
    key: 'coupon',
    tabName: '优惠卡券',
    tabActiveColor: '#ffe7f1',
    tabBgColor: '#fec2d099',
  },
];

// 实验地址：https://fat-ab.hellobike.cn/experiment/detail/202604211707392585?isDetail=true
// moduleKey → cashback 组件映射
export const MODULE_KEY_CASHBACK_STYLE = {
  welfare_rake_back: 'CashbackPurchase',
  welfare_takeout_rebate_module: 'CashbackPurchaseV2',
  welfare_cheese_rebate_module: 'CashbackPurchaseV2',
};

// 福利中心红包ab实验
export const RED_PACKET_AB = {
  oldVersion: '0', // 老版本
  newVersionNoBanner: '1', // 新版无banner广告
  newVersionWithBanner: '2', // 新版有banner广告
};

// 福利中心阶梯视频ab实验
export const TIERED_VIDEO_AB = {
  oldVersion: '2', // 新版样式+非连续观看
  newVersionWithBanner: '3', // 阶梯有banner广告
  newVersionNoBanner: '4', // 阶梯无banner广告
};

// 优量汇广告任务完成类型集合
export const GDT_COMPLETE_ACTIONS = ['downloadCompleted', 'installCompleted', 'viewCompleted'];

// 福利中心广告来源场景
export const ADV_SCENE = {
  SIGN_IN: '1', // 签到
  CASHBACK_TASK: '2', // 单单返任务
  VIDEO_RED_PACKET: '3', // 红包视频任务
  INCENTIVE_VIDEO: '4', // 激励视频任务
  REWARD_POPUP: '5', // 领奖弹窗
};

// bounty-tab 可配置副标题的统一文本样式（HighlightText 的 normalStyle / highlightStyle）
// 4 个目标模块共用，改色/调字号只需改这里一处
export const SUBTITLE_NORMAL_STYLE = {
  color: '#5A6066',
  fontWeight: 400,
  fontSize: '0.12rem',
};
export const SUBTITLE_HIGHLIGHT_STYLE = {
  color: '#FE852A',
  fontWeight: 600,
  fontSize: '0.12rem',
};
